import React, { useEffect } from "react";

import Navbar from "./clientHom/Navbar";
import Footer from "./uniComponents/AndUsFooter";
import ContactAndUsSection from "./contactAndUs/ContactAndUsSection";

import "./ContactAndUsPage.css";

export default function ContactAndUsPage() {
  useEffect(() => {
    const previousTitle = document.title;

    document.title = "Contact &Us | AndUs";
    window.scrollTo(0, 0);

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div
      id="contact-andus-page-top"
      className="contact-andus-page"
    >
      <Navbar />

      <main className="contact-andus-page__main">
        <ContactAndUsSection />
      </main>

      <Footer />
    </div>
  );
}